import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, SparklesIcon, MessageSquareIcon, RocketIcon, ArrowRightIcon } from 'lucide-react';
const CommunityCTA = () => {
  return <section className="w-full bg-gradient-to-b from-white to-gray-50 py-16 sm:py-24 md:py-32 lg:py-48" data-id="element-52">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-53">
        <div className="max-w-5xl mx-auto" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12 sm:mb-14 md:mb-16" data-id="element-55">
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-200 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-4 sm:mb-6" data-id="element-56">
              <SparklesIcon className="w-3 h-3 sm:w-4 sm:h-4 text-orange-500" data-id="element-57" />
              <span className="text-xs sm:text-sm font-semibold text-orange-900" data-id="element-58">
                Join Early
              </span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 tracking-tight leading-tight px-4" data-id="element-59">
              Join FluidWeb Community
            </h2>

            <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto leading-relaxed mb-10 sm:mb-12 px-4" data-id="element-60">
              Connect with developers, PMs, and designers building the future of
              agentic interfaces. Get early access, shape the roadmap, and learn
              from peers.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 mb-10 sm:mb-12" data-id="element-61">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 p-6 sm:p-8 text-center shadow-sm" data-id="element-62">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg sm:rounded-xl flex items-center justify-center mx-auto mb-3 sm:mb-4" data-id="element-63">
                <UsersIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-64" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg" data-id="element-65">
                Early Access
              </h3>
              <p className="text-sm text-gray-600" data-id="element-66">
                First access to new features and beta releases
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 p-6 sm:p-8 text-center shadow-sm" data-id="element-67">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg sm:rounded-xl flex items-center justify-center mx-auto mb-3 sm:mb-4" data-id="element-68">
                <MessageSquareIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-69" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg" data-id="element-70">
                Direct Influence
              </h3>
              <p className="text-sm text-gray-600" data-id="element-71">
                Shape the product roadmap with your feedback
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 p-6 sm:p-8 text-center shadow-sm" data-id="element-72">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg sm:rounded-xl flex items-center justify-center mx-auto mb-3 sm:mb-4" data-id="element-73">
                <RocketIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-74" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg" data-id="element-75">
                Learn & Share
              </h3>
              <p className="text-sm text-gray-600" data-id="element-76">
                Exchange patterns and best practices with peers
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-center" data-id="element-77">
            <a href="/community" className="inline-flex items-center justify-center gap-3 bg-orange-500 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-orange-600 transition-all shadow-lg shadow-orange-500/20 min-h-[44px]" data-id="element-78">
              <UsersIcon size={20} data-id="element-79" />
              Join Community
              <ArrowRightIcon size={20} data-id="element-80" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default CommunityCTA;